import ConfigurableTable, {
  ColumnConfig as ColumnConfigInternal
} from "./ConfigurableTable";

const pickConfigs = (
  columns: ColumnConfig[],
  picked: string[]
): ColumnConfig[] => {
  return picked.map(name => {
    const config = columns.find(config => config.name === name);
    if (!config) {
      throw new Error(`Unable to find column config for ${name}`);
    }
    return config;
  });
};

export { pickConfigs };
export type ColumnConfig = ColumnConfigInternal;
export default ConfigurableTable;
